<template>
  <div>
    <a-spin :spinning="isLoading">
      <div class="flex">
        <h2 class="text-2xl">Edit Advertisement</h2>
      </div>
      <div class="grid grid-cols-6 gap-8">
        <div class="col-span-4">
          <Form v-model="form" v-model:mediaType="mediaType" />
        </div>
        <div class="col-span-2">
          <Ad :data="form" />
        </div>
        <div class="col-span-5 flex justify-evenly pb-4">
          <button 
          class="bg-red-500 hover:bg-red-700 text-white font-bold px-4 rounded flex items-center" 
          @click="modalIsVisible = true" 
          >
          Delete
          </button>
          <router-link to="/advertisements">
            <a-button>Cancel</a-button>
          </router-link>
          <a-button type="primary" @click="onSubmit">
            Save
          </a-button>
        </div>
      </div>
    </a-spin>
    <Modal v-model:isVisible="modalIsVisible" v-model:id="this.$route.params.id"/>
  </div>
</template>

<script>
import Form              from "@/components/Form";
import Ad                from "@/components/Ad";
import Modal             from "@/components/Modals/DeleteAds";
import { ref, computed } from "vue";
import { useStore }      from "vuex";

export default {
  components: { Form, Ad, Modal },
  async mounted() {
    const data = await this.$store.dispatch(
      "GET_ADVERTISEMENT_BY_ID",
      this.$route.params.id
    );
    this.form = { ...this.form, ...data.data };
  },
  setup(){
    const store = useStore();

    const modalIsVisible = ref(false);

    const modal = computed(() => store.state.modalIsVisible);

    return { modalIsVisible, modal };
  },
  data() {
    return {
      isLoading: false,
      subindustries: null,
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      mediaType: "link",
      form: {
        user_id: "1",
        visible: false,
        new: false,
        name: null,
        logo: null,
        collections: [],
        media_source: null,
        primary_text: null,
        headline: null,
        description: null,
        display_link: null,
        call_to_action: null,
        analysis: null,
        tags: [],
        industry: null,
        subindustry: null,
        type: null,
        seasonal: null,
        format: null,
        video_type: null,
        video_length: null,
        gender: null,
        objective: null,
        placement: false,
      },
    };
  },
  methods: {
    async onSubmit() {
      const { success } = await this.updateAdvertisement();
      if (success) {
        this.$router.push("/advertisements");
      }
    },
    async updateAdvertisement() {
      this.isLoading = true;
      const advertisement = await this.$store.dispatch(
        "UPDATE_ADVERTISEMENT",
        this.form
      );
      if (this.mediaType == "file") {
        const media = await this.uploadFile(advertisement.data.id);
        this.isLoading = false;
        return media;
      }
      this.isLoading = false;
      return advertisement;
    },
    async uploadFile(id) {
      let formdata = new FormData();
      formdata.append("id", id);
      formdata.append("folder", "media");
      formdata.append("file", this.form.media_source);
      return await this.$store.dispatch("UPLOAD_ADVERTISEMENT_MEDIA", formdata);
    },
  },
};
</script>

<style scoped>
.advertisements__new__actions button ~ button,
.advertisements__new__actions a ~ a,
.advertisements__new__actions a ~ button,
.advertisements__new__actions button ~ a {
  margin-left: 10px;
}
.custom_select--group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 10px;
}
</style>
